import React, { Component } from "react";
import SignatureCanvas from "react-signature-canvas";
import "./SignaturePad.css";

class SignaturePad extends Component {
    constructor(props) {
        super(props);

        this.signatureRef = null;

        this.state = {
            hasSignature: false
        };
    }

    setSignatureRef = (ref) => {
        this.signatureRef = ref;
    };

    handleDrawEnd = () => {
        if (!this.signatureRef) {
            return;
        }
        const hasSignature = !this.signatureRef.isEmpty();
        this.setState({ hasSignature });

        if (typeof this.props.onDrawEnd === "function") {
            this.props.onDrawEnd(hasSignature);
        }
    };

    getTrimmedSignatureDataUrl = () => {
        if (!this.signatureRef || this.signatureRef.isEmpty()) {
            return "";
        }

        const sourceCanvas = this.signatureRef.getTrimmedCanvas();
        if (!sourceCanvas) {
            return "";
        }

        const horizontalPadding = this.props.exportPaddingX !== undefined ? this.props.exportPaddingX : 8;
        const verticalPadding = this.props.exportPaddingY !== undefined ? this.props.exportPaddingY : 4;
        const exportWidth = sourceCanvas.width + (horizontalPadding * 2);
        const exportHeight = sourceCanvas.height + (verticalPadding * 2);

        const exportCanvas = document.createElement("canvas");
        exportCanvas.width = exportWidth;
        exportCanvas.height = exportHeight;

        const exportContext = exportCanvas.getContext("2d");
        if (!exportContext) {
            return sourceCanvas.toDataURL("image/png");
        }

        const backgroundColor = this.props.backgroundColor || "#ffffff";
        exportContext.fillStyle = backgroundColor;
        exportContext.fillRect(0, 0, exportWidth, exportHeight);
        exportContext.drawImage(sourceCanvas, horizontalPadding, verticalPadding);

        return exportCanvas.toDataURL("image/png");
    };

    clear = () => {
        if (!this.signatureRef) {
            return;
        }

        this.signatureRef.clear();
        this.setState({ hasSignature: false });

        if (typeof this.props.onClear === "function") {
            this.props.onClear();
        }
        if (typeof this.props.onDrawEnd === "function") {
            this.props.onDrawEnd(false);
        }
    };

    hasSignature = () => {
        if (!this.signatureRef) {
            return false;
        }
        return !this.signatureRef.isEmpty();
    };

    getSignatureDataUrl = () => {
        return this.getTrimmedSignatureDataUrl();
    };

    render() {
        const width = this.props.width || 320;
        const height = this.props.height || 180;
        const showActions = this.props.showActions !== false;

        return (
            <div className="signature-pad">
                <SignatureCanvas
                    ref={this.setSignatureRef}
                    onEnd={this.handleDrawEnd}
                    penColor={this.props.penColor || "#1f2937"}
                    minWidth={this.props.lineWidth || 2}
                    maxWidth={this.props.lineWidth || 2}
                    backgroundColor={this.props.backgroundColor || "#ffffff"}
                    canvasProps={{
                        className: "signature-pad__canvas",
                        width,
                        height
                    }}
                />
                {showActions ? (
                    <div className="signature-pad__actions">
                        <button
                            type="button"
                            className="btn btn-default btn-fill"
                            onClick={this.clear}
                        >
                            Wyczyść
                        </button>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default SignaturePad;
